var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcSocialFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 0H0.6C0.268125 0 0 0.268125 0 0.6V14.4C0 14.7319 0.268125 15 0.6 15H14.4C14.7319 15 15 14.7319 15 14.4V0.6C15 0.268125 14.7319 0 14.4 0ZM13.8 13.8H10.3481V9.19125H12.2981L12.5906 6.92813H10.3481V5.4825C10.3481 4.82625 10.53 4.38 11.4694 4.38H12.6675V2.355C12.4594 2.32688 11.7488 2.265 10.92 2.265C9.19125 2.265 8.00813 3.32063 8.00813 5.2575V6.92625H6.05438V9.18937H8.01V13.8H1.2V1.2H13.8V13.8Z",
    fill: "#242A37"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSocialFacebook);
export default __webpack_public_path__ + "static/media/ic_social_facebook.08ebbeeb1f97b56122628403479184f3.svg";
export { ForwardRef as ReactComponent };